import * as React from 'react';
import NavigationBar from 'app/components/HeaderComponent/NavigationBar';
import UserHeaderArea from 'app/components/HeaderComponent/userHeaderArea';
import { Link } from 'react-router-dom';
import { state } from '__common/store';

const Header: React.StatelessComponent<headerComponentState> = ({ navigation, Infobar, productId, projectId, isAtHomePage }: {navigation :boolean, Infobar?: JSX.Element, projectId?: string, productId?: string, isAtHomePage?: boolean }) => {
  const {projectConfiguration} = state();
  const isAurora = projectConfiguration?.projectEnvConfig?.aurora_project_id || projectConfiguration?.is_aurora_project;
  const isOs = projectConfiguration?.projectEnvConfig?.os_project_id || projectConfiguration?.is_os_project;
  const ubuilderLogoSrc = isAtHomePage ? 'White_U-Builder_new_logo' : 'U-Builder_pro_header_logo';
  const logo = <img src={require(`assets/media/logos/${ubuilderLogoSrc}.png`)} className="ubuilder-logo-at-header" alt="U-Builder" />;
  return (
    <div className="header">
      <div className="header-row top-row">
        <div className="ubuilder-header-logo">
          {(isAurora || isOs) ? logo : <Link to="/" aria-label="Go to U-Builder home">{logo}</Link>}
        </div>
        <UserHeaderArea />
      </div>
      {(Infobar || navigation) && (
        <div className="second-row">
          {Infobar && <div className="header-row middle-row">{Infobar}</div>}
          {navigation ? <div className="header-row bottom-row"><NavigationBar productId={productId} projectId={projectId} /></div> : ''}
        </div>
      )}
    </div>
  );
};

export default Header;
